import {
  ApolloClient,
  ApolloLink,
  type ErrorLike,
  HttpLink,
} from '@apollo/client';

import { APOLLO_DEFAULT_OPTIONS } from '@/apollo/constants/ApolloDefaultOptions';
import { createApolloCache } from '@/apollo/utils/createApolloCache';
import { createAuthLink } from '@/apollo/utils/createAuthLink';
import { createErrorLink } from '@/apollo/utils/createErrorLink';
import { createLocaleLink } from '@/apollo/utils/createLocaleLink';

type CreateApolloClientArgs = {
  uri: string;
  getAuthToken: () => Promise<string | null>;
  onUnauthenticated: () => void;
  onUnexpectedError: (error: ErrorLike) => void;
};

export const createApolloClient = ({
  uri,
  getAuthToken,
  onUnauthenticated,
  onUnexpectedError,
}: CreateApolloClientArgs) =>
  new ApolloClient({
    cache: createApolloCache(),
    defaultOptions: APOLLO_DEFAULT_OPTIONS,
    link: ApolloLink.from([
      createLocaleLink(),
      createAuthLink({ getAuthToken }),
      createErrorLink({ onUnauthenticated, onUnexpectedError }),
      new HttpLink({ uri }),
    ]),
  });
